import { useState, useEffect } from 'react';
import api from '../api';

/**
 * Custom hook to fetch and manage trial status
 * @returns {object} Trial status data and methods
 */
export const useTrial = () => {
  const [trialStatus, setTrialStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTrialStatus = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await api.get('/trial-status');
      setTrialStatus(response.data);
    } catch (err) {
      console.error('Failed to fetch trial status:', err);
      setError(err.response?.data?.error || 'Failed to load trial status');
      // Don't show error if user is not on trial (404 is expected for non-trial users)
      if (err.response?.status === 404) {
        setTrialStatus({ isOnTrial: false });
        setError(null);
      }
    } finally {
      setLoading(false);
    }
  };

  const upgradeNow = async () => {
    try {
      const response = await api.post('/upgrade-now');
      // Refresh trial status after upgrade
      await fetchTrialStatus();
      return response.data;
    } catch (err) {
      console.error('Upgrade failed:', err);
      throw new Error(err.response?.data?.error || 'Upgrade failed');
    }
  };

  useEffect(() => {
    fetchTrialStatus();
  }, []);

  return {
    trialStatus,
    loading,
    error,
    refreshTrialStatus: fetchTrialStatus,
    upgradeNow,
    isOnTrial: trialStatus?.isOnTrial || false,
    daysRemaining: trialStatus?.daysRemaining || 0,
    limits: trialStatus?.limits || {},
  };
};

export default useTrial;
